import { Stack } from '@fluentui/react';
import {
  DropdownFilter,
  FilterArrayType,
  FilterElement,
} from 'common/components/Filters';
import { getUpdatedFilterArray } from 'common/components/Filters/utils';
import {
  ColumnData,
  SearchBar,
  SearchBarProps,
} from 'common/components/SearchBar';
import { formatDropdownOptions } from 'common/utils';
import React, { useState } from 'react';
import { FileCabinetCommonData } from '../__generated__/FileCabinetCommonData';
import { ToggleFilter } from 'common/components/Filters/ToggleFilter';
interface DocumentsSearchBar extends SearchBarProps {
  onHintsViewToggle?: () => void;
  columns: ColumnData[];
  onFilterChange: (filterArray: FilterArrayType[]) => void;
  onToggleVisibility?: (columns: ColumnData[]) => void;
  toggleActions?: () => void;
  fileCabinetCommonData: FileCabinetCommonData | undefined;
}
export const DocumentsSearchBar: React.FC<DocumentsSearchBar> = ({
  columns,
  onEnterPress,
  onRefresh,
  searchInputPlaceholderText,
  onToggleVisibility,
  urlParams,
  onFilterChange,
  onGlobalToggle,
  fileCabinetCommonData,
}) => {
  const [filterTypes, setFilterTypes] = useState<FilterArrayType[]>([]);

  const businessUnitOptions = formatDropdownOptions(
    fileCabinetCommonData?.companyBusinessUnits?.nodes,
    {
      getKey: (item) => item.id,
      getText: (item) => item.name || '',
      includeAll: true,
    }
  );

  const departmentOptions = formatDropdownOptions(
    fileCabinetCommonData?.companyDepartments?.nodes,
    {
      getKey: (item) => item.id,
      getText: (item) => item.name || '',
      includeAll: true,
    }
  );
  const currencyOptions = formatDropdownOptions(
    fileCabinetCommonData?.companyCurrencies?.nodes,
    {
      getKey: (item) => item.id,
      getText: (item) => item.isoCode || '',
      includeAll: true,
    }
  );
  const documentTypeOptions = formatDropdownOptions(
    fileCabinetCommonData?.fileCabinetDocumentTypes?.nodes,
    {
      getKey: (item) => item.id,
      getText: (item) => item.documentType || '',
      includeAll: true,
    }
  );
  const poolOptions = formatDropdownOptions(
    fileCabinetCommonData?.fileCabinetPools?.nodes,
    {
      getKey: (item) => item.id,
      getText: (item) => item.name,
      includeAll: true,
    }
  );

  const processHistoryOptions = formatDropdownOptions(
    fileCabinetCommonData?.fileCabinetProcessHistories?.nodes,
    {
      getKey: (item) => item.id,
      getText: (item) => item.exportInfo ?? '',
      includeAll: true,
      multiSelect: true,
    }
  );
  const onOptionChange = (filterdata: FilterArrayType) => {
    const availableFilters = [...filterTypes];
    const newFilters = getUpdatedFilterArray(filterdata, availableFilters);
    onFilterChange?.(newFilters);
    setFilterTypes(newFilters);
  };

  const filters: FilterElement[] = [
    <DropdownFilter
      filterKey={'filterBusinessUnitId'}
      options={businessUnitOptions}
      placeholder={'Business Unit'}
      onOptionChange={onOptionChange}
    />,
    <DropdownFilter
      filterKey={'filterDepartmentId'}
      options={departmentOptions}
      placeholder={'Department'}
      onOptionChange={onOptionChange}
    />,
    <DropdownFilter
      filterKey={'filterCurrencyId'}
      options={currencyOptions}
      placeholder={'Currency'}
      onOptionChange={onOptionChange}
    />,
    <DropdownFilter
      filterKey={'filterDocumentTypeId'}
      options={documentTypeOptions}
      placeholder={'Document Type'}
      onOptionChange={onOptionChange}
    />,
    <DropdownFilter
      filterKey={'filterFolderId'}
      options={poolOptions}
      placeholder={'Folder'}
      onOptionChange={onOptionChange}
    />,
    <DropdownFilter
      filterKey={'filterProcessHistoryId'}
      options={processHistoryOptions}
      placeholder={'Exported'}
      onOptionChange={onOptionChange}
      width={150}
      maxHeight={400}
      multiSelect
    />,
    <ToggleFilter
      placeholder="New"
      inlineLabel
      filterKey="isFilterUnprocessedDocuments"
      onOptionChange={onOptionChange}
    />,
  ];

  return (
    <SearchBar
      onFilterClear={() => {
        if (filterTypes.length) onFilterChange([]);
        setFilterTypes([]);
      }}
      onGlobalToggle={onGlobalToggle}
      isGlobalAvailable={false}
      urlParams={urlParams}
      columns={columns}
      searchInputPlaceholderText={searchInputPlaceholderText}
      onEnterPress={onEnterPress}
      onRefresh={onRefresh}
      hintsAvailable={false}
      onToggleVisibility={onToggleVisibility}
      filters={filters}
    />
  );
};
